import styled from 'styled-components/macro';

export const Container = styled.div`
  height: 100%;
  display: flex;
  background-color: ${({ theme, type }) =>
    type === 'away' ? theme.dark4 : theme.light};
  background-image: url(${({ bgImage }) => bgImage});
  background-position: calc(100% + 66px) center;
  background-size: 223px;
  background-repeat: no-repeat;
`;
